import { Button, Group, Stack, Text } from '@mantine/core';

import { EnvironmentCountries, TransitGuarantee } from '@e-origin/shared';

import { refactorIcon } from '@assets';
import { useSettings } from '@hooks/useSettings';
import { transitGuaranteesModalManager } from './transitGuaranteesModalManager';

interface GuaranteeDisplayProps {
  guarantee: TransitGuarantee;
  onSave: (values: TransitGuarantee) => void;
}

export const TransitGuaranteeData: React.FC<GuaranteeDisplayProps> = ({ guarantee, onSave }) => {
  const { data: settings } = useSettings();

  const updateGuaranteeData = () => {
    transitGuaranteesModalManager.openEditGuarantee(guarantee, onSave);
  };

  return (
    <Stack>
      <Group mb="sm" gap="xl">
        <Stack gap={4}>
          <Text size="sm" c="dimmed">
            Type
          </Text>
          <Text>{guarantee.type || '-'}</Text>
        </Stack>
        <Stack gap={4}>
          <Text size="sm" c="dimmed">
            GRN
          </Text>
          <Text>{guarantee.reference.grn || '-'}</Text>
        </Stack>
        <Stack gap={4}>
          <Text size="sm" c="dimmed">
            Default amount
          </Text>
          <Text>{guarantee.reference.amountToBeCovered || '-'}</Text>
        </Stack>
        <Stack gap={4}>
          <Text size="sm" c="dimmed">
            Currency
          </Text>
          <Text>{guarantee.reference.currencyCode || '-'}</Text>
        </Stack>
        {settings?.country === EnvironmentCountries.NL && (
          <>
            <Stack gap={4}>
              <Text size="sm" c="dimmed">
                Query type
              </Text>
              <Text>{guarantee.queryIdentifier || '-'}</Text>
            </Stack>
            <Stack gap={4}>
              <Text size="sm" c="dimmed">
                Owner ID
              </Text>
              <Text>{guarantee.ownerId || '-'}</Text>
            </Stack>
          </>
        )}
        <Group gap={0}>
          <Button type="button" onClick={updateGuaranteeData} variant="transparent">
            <img src={refactorIcon} alt="Update guarantee data" />
          </Button>
        </Group>
      </Group>
    </Stack>
  );
};
